module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('md-app', {
    attrs: {
      "md-mode": "reveal"
    }
  }, [_c('md-app-toolbar', {
    staticClass: "md-primary"
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("SDK管理后台(Mobile版)")])]), _vm._v(" "), _c('md-app-drawer', {
    attrs: {
      "md-active": _vm.menuVisible
    },
    on: {
      "update:mdActive": function($event) {
        _vm.menuVisible = $event
      },
      "update:md-active": function($event) {
        _vm.menuVisible = $event
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent",
    attrs: {
      "md-elevation": "0"
    }
  }, [_vm._v("菜单")]), _vm._v(" "), _c('md-list', [_c('md-list-item', [_c('md-icon', [_vm._v("move_to_inbox")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_c('a', {
    attrs: {
      "href": "/#/product/index"
    }
  }, [_vm._v("产品列表")])])], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', [_vm._v("send")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_c('a', {
    attrs: {
      "href": "/#/space/index"
    }
  }, [_vm._v("广告位")])])], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', [_vm._v("send")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_c('a', {
    attrs: {
      "href": "/#/plan/index"
    }
  }, [_vm._v("广告投放")])])], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("屏蔽策略")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', [_vm._v("error")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("扣量策略")])], 1)], 1)], 1), _vm._v(" "), _c('md-app-content', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    ref: "myMain"
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// D:/发行部门文件/后台管理系统文件/~/vue-loader/lib/template-compiler?{"id":"data-v-4312014f"}!D:/发行部门文件/后台管理系统文件/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 525
// module chunks = 0